// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.completeS {
  margin-left: 170px;
  margin-top: 70px;
  max-width: 850px;
  margin: 72 auto;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  /* font-family: 'Roboto', sans-serif; */
}

.reportdCompleteS {
  margin-left: 170px;
  margin-top: 30px;
  max-width: 850px;
  margin: 72 auto;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  text-align: center;
  /* font-family: 'Roboto', sans-serif; */
}

/* Button Styling */
.generate-pdf-button {
  display: inline-flex;
  align-items: center;
  background-color: #07a6ef;
  padding: 7px 10px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
  margin-left: 15px;
  border-radius: 5px;
}

.generate-pdf-button:hover {
  background-color: #07a6ef;
}

.generate-pdf-button svg {
  margin-right: 2px;
}

/* Tile Container */
.tile-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}

/* Tile Styling */
.tile {
  flex: 1 1;
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

/* Section Titles */
.tile h4,
.tile h5 {
  font-size: 20px;
  font-weight: 600;
  color: #07a6ef;
  margin-bottom: 10px;
}

/* Personal and Order Info Styling */
.personalInfo div,
.personS div {
  font-size: 16px;
  margin-bottom: 8px;
  color: #495057;
}

/* Table Styling */
.bx3 table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.bx3 th,
.bx3 td {
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

.bx3 th {
  background-color: #f1f1f1;
  font-weight: 600;
  font-size: 16px;
  color: #343a40;
}

.bx3 td {
  font-size: 14px;
  color: #495057;
}

.bx3 tr:last-child td {
  border-bottom: none;
}

/* Table Total Row */
.bx3 tbody tr:last-of-type td {
  font-weight: 600;
  font-size: 16px;
  color: #07a6ef;
}

/* Tooltip Styling */
.tooltip {
  background-color: #000000;
  color: #ffffff;
  border-radius: 4px;
  padding: 5px;
  font-size: 12px;
}
.pdfhead {
  font-weight: bold;
}

.bx4 table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.bx4 th,
.bx4 td {
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

.bx4 th {
  background-color: #f1f1f1;
  font-weight: 600;
  font-size: 16px;
  color: #343a40;
  width: 80px;
}

.bx4 td {
  font-size: 14px;
  color: #495057;
}

.bx4 tr:last-child td {
  border-bottom: none;
}

/* Media Queries for Responsiveness */
@media (max-width: 768px) {
  .tile-container {
    flex-direction: column;
  }

  .tile {
    margin-bottom: 20px;
  }

  .generate-pdf-button {
    width: 100%;
    text-align: center;
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/Driverpdf.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EAEjB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;;EAEE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/* Main Container */\r\n.completeS {\r\n  margin-left: 170px;\r\n  margin-top: 70px;\r\n  max-width: 850px;\r\n  margin: 72 auto;\r\n  background: #ffffff;\r\n  border: 1px solid #dddddd;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n  /* font-family: 'Roboto', sans-serif; */\r\n}\r\n\r\n.reportdCompleteS {\r\n  margin-left: 170px;\r\n  margin-top: 30px;\r\n  max-width: 850px;\r\n  margin: 72 auto;\r\n  background: #ffffff;\r\n  border: 1px solid #dddddd;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n  /* font-family: 'Roboto', sans-serif; */\r\n}\r\n\r\n/* Button Styling */\r\n.generate-pdf-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  background-color: #07a6ef;\r\n  padding: 7px 10px;\r\n  border-radius: 4px;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  transition: background-color 0.3s;\r\n  margin-left: 15px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.generate-pdf-button:hover {\r\n  background-color: #07a6ef;\r\n}\r\n\r\n.generate-pdf-button svg {\r\n  margin-right: 2px;\r\n}\r\n\r\n/* Tile Container */\r\n.tile-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Tile Styling */\r\n.tile {\r\n  flex: 1;\r\n  background-color: #f8f9fa;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* Section Titles */\r\n.tile h4,\r\n.tile h5 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #07a6ef;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Personal and Order Info Styling */\r\n.personalInfo div,\r\n.personS div {\r\n  font-size: 16px;\r\n  margin-bottom: 8px;\r\n  color: #495057;\r\n}\r\n\r\n/* Table Styling */\r\n.bx3 table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 10px;\r\n}\r\n\r\n.bx3 th,\r\n.bx3 td {\r\n  text-align: left;\r\n  padding: 12px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.bx3 th {\r\n  background-color: #f1f1f1;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  color: #343a40;\r\n}\r\n\r\n.bx3 td {\r\n  font-size: 14px;\r\n  color: #495057;\r\n}\r\n\r\n.bx3 tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Table Total Row */\r\n.bx3 tbody tr:last-of-type td {\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  color: #07a6ef;\r\n}\r\n\r\n/* Tooltip Styling */\r\n.tooltip {\r\n  background-color: #000000;\r\n  color: #ffffff;\r\n  border-radius: 4px;\r\n  padding: 5px;\r\n  font-size: 12px;\r\n}\r\n.pdfhead {\r\n  font-weight: bold;\r\n}\r\n\r\n.bx4 table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-top: 10px;\r\n}\r\n\r\n.bx4 th,\r\n.bx4 td {\r\n  text-align: left;\r\n  padding: 12px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.bx4 th {\r\n  background-color: #f1f1f1;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  color: #343a40;\r\n  width: 80px;\r\n}\r\n\r\n.bx4 td {\r\n  font-size: 14px;\r\n  color: #495057;\r\n}\r\n\r\n.bx4 tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n/* Media Queries for Responsiveness */\r\n@media (max-width: 768px) {\r\n  .tile-container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .tile {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .generate-pdf-button {\r\n    width: 100%;\r\n    text-align: center;\r\n    font-size: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
